import AreaPage from "@/components/AreaPage";

const area = {
  name: "Palam Vihar",
  slug: "water-tank-cleaning-palam-vihar-gurugram",
  h1: "Water Tank Cleaning in Palam Vihar, Gurugram",
  description: "Water tank cleaning in Palam Vihar Gurugram. Residential homes, apartments, and societies. Starting ₹999.",
  content1: "Palam Vihar is a well-planned residential colony in Gurugram known for its organized sectors, parks, and family-friendly environment. TankBuddy serves homeowners across all blocks of Palam Vihar with affordable, professional water tank cleaning. Whether you have a small overhead tank or a larger underground reservoir, our team arrives on time and completes the job efficiently.",
  content2: "Many Palam Vihar residences were built 15-20 years ago with concrete tanks that require specialized cleaning to remove years of mineral scaling and biofilm. TankBuddy's expertise in cleaning older RCC tanks, combined with our eco-friendly sanitization process, makes us the preferred choice for Palam Vihar families. We also offer attractive rates for group bookings within the same block or sector.",
  nearby: [
    { href: "/water-tank-cleaning-dlf-phase-gurugram", label: "DLF Phase 1-5" },
    { href: "/water-tank-cleaning-sushant-lok-gurugram", label: "Sushant Lok" },
    { href: "/water-tank-cleaning-udyog-vihar-gurugram", label: "Udyog Vihar" },
    { href: "/water-tank-cleaning-mg-road-gurugram", label: "MG Road" },
  ],
};

export default function PalamViharPage() {
  return <AreaPage area={area} />;
}
